import DraftsPage from './DraftsPage';

export default DraftsPage;
